import { useState } from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import BookAppointmentModal from "../BookAppointmentModal/BookAppointmentModal";
import "./ClinicCard.css";

export const ClinicCard = ({
  avatar,
  name,
  role,
  isOnline,
  country,
  date,
  time,
  totalSlots,
  availableSlots,
  waitingTime,
  fees,
  onDateChange,
  onTimeChange,
}) => {
  const [showModal, setShowModal] = useState(false);

  const [selectedDate, setSelectedDate] = useState(() => {
    try {
      const d = date ? new Date(date) : null;
      return d && !isNaN(d.getTime()) ? d : null;
    } catch {
      return null;
    }
  });

  const [selectedTime, setSelectedTime] = useState(() => {
    try {
      if (!time) return null;
      const [h, m] = time.split(":");
      const d = new Date();
      d.setHours(Number(h), Number(m), 0, 0);
      return !isNaN(d.getTime()) ? d : null;
    } catch {
      return null;
    }
  });

  const handleDateChange = (val) => {
    setSelectedDate(val);
    onDateChange?.(val);
  };

  const handleTimeChange = (val) => {
    setSelectedTime(val);
    onTimeChange?.(val);
  };

  const formatDate = (d) =>
    d
      ? d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
      : "Select date";

  const formatTime = (d) =>
    d
      ? d.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })
      : "Select time";

  return (
    <>
      <div className="clinic-card">
        {/* Header */}
        <div className="clinic-card__header">
          <div className="clinic-card__avatar-wrap">
            <img src={avatar} alt={name} className="clinic-card__avatar" />
            <span
              className={`clinic-card__status-dot ${isOnline ? "clinic-card__status-dot--online" : "clinic-card__status-dot--offline"}`}
            />
          </div>
          <div className="clinic-card__header-text">
            <a href="#!" className="clinic-card__name">{name}</a>
            <p className="clinic-card__role">{role}</p>
          </div>
        </div>

        {/* Body */}
        <div className="clinic-card__body">
          <a href="#!" className="clinic-card__view-profile">View Profile</a>

          <p className="clinic-card__label">Country/City</p>
          <div className="clinic-card__field">{country}</div>

          <p className="clinic-card__label">Schedule (Date/Time)</p>
          <div className="clinic-card__schedule-row">
            <div className="clinic-card__field clinic-card__field--half clinic-card__field--picker">
              <svg className="clinic-card__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
              </svg>
              <ReactDatePicker
                selected={selectedDate}
                onChange={handleDateChange}
                dateFormat="dd MMM yyyy"
                placeholderText="Select date"
                customInput={
                  <button className="clinic-card__picker-btn" type="button">
                    {formatDate(selectedDate)}
                  </button>
                }
                popperPlacement="bottom-start"
              />
            </div>

            <div className="clinic-card__field clinic-card__field--half clinic-card__field--picker">
              <svg className="clinic-card__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
              <ReactDatePicker
                selected={selectedTime}
                onChange={handleTimeChange}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                timeCaption="Time"
                dateFormat="h:mm aa"
                placeholderText="Select time"
                customInput={
                  <button className="clinic-card__picker-btn" type="button">
                    {formatTime(selectedTime)}
                  </button>
                }
                popperPlacement="bottom-start"
              />
            </div>
          </div>

          <p className="clinic-card__label">No. Of Slots</p>
          <div className="clinic-card__slots-row">
            <div className="clinic-card__slot-box">
              <span className="clinic-card__slot-num">{totalSlots}</span>
              <span className="clinic-card__slot-sub">Total Slots</span>
            </div>
            <div className="clinic-card__slot-box">
              <span className="clinic-card__slot-num">{availableSlots}</span>
              <span className="clinic-card__slot-sub">Available Slots</span>
            </div>
          </div>

          <p className="clinic-card__label">Waiting Time</p>
          <div className="clinic-card__field clinic-card__field--center">{waitingTime}</div>

          <div className="clinic-card__btn-row">
            <button
              className="clinic-card__btn-primary"
              onClick={() => setShowModal(true)}
            >
              Book Appointment
            </button>
            <button className="clinic-card__btn-outline">Join</button>
          </div>
        </div>
      </div>

      <BookAppointmentModal
        show={showModal}
        onHide={() => setShowModal(false)}
        fees={fees}
      />
    </>
  );
};
